<template>
  <!-- MAP -->
  <div id="map" ref="map" class="w-full h-96"></div>
</template>

<script>

export default {
  components: {
  },

  props: {
		list: {
			type: Array
		},
  },

  data() {
    return {
      // MAP
      map: null,
      // MAPピン
      markers: [],
    }
  },

  async mounted() {
    this.initMap()
  },

  watch: {
    list() {
      this.createMap()
    }
  },

  methods: {
    /**
     * MAP
     */
    async initMap() {

      // アポロ管財のビル
      const lat = 35.62428411048763
      const lng = 139.57938708329655

      this.map = new google.maps.Map(this.$refs.map, {
        center: { lat, lng },
        zoom: 15,
        styles: [
          {
            featureType: 'poi',  // ← 公園・店・学校など
            elementType: 'labels', // ← ラベルを対象
            stylers: [{ visibility: 'off' }] // ← 非表示に
          },
          // {
          //   featureType: 'poi.business', // ← 店舗系を個別にOFFも可
          //   stylers: [{ visibility: 'off' }]
          // },
          {
            featureType: 'transit', // ← 駅なども消す
            stylers: [{ visibility: 'off' }]
          }
        ]
      })

      this.createMap()
    },

    /**
     * マーカー生成
     */
    createMap() {
      // 既存マーカーを削除
      this.markers.forEach(m => m.setMap(null))
      this.markers = []

      // 範囲オブジェクトを作成
      const bounds = new google.maps.LatLngBounds()

      this.list.forEach(p => {
        const latLng = new google.maps.LatLng(Number(p.lat), Number(p.lng))
          const marker = new google.maps.Marker({
            position: latLng,
            map: this.map,
            label: {
              text: p.site,
              color: '#FF00FF',
              fontSize: '13px',
              fontWeight: 'bold'
            },
            icon: {
              url: '/images/yellow.png'
            }
          })
          this.markers.push(marker)
          bounds.extend(latLng) // ← 各ピンを範囲に追加
      })

      // ピンが1つ以上あれば中央に合わせる
      if (this.list.length > 0) {
        this.map.fitBounds(bounds)

        // 拡大しすぎるのを防ぐ（ピンが1つの場合など）
        google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
          if (this.map.getZoom() > 16) {
            this.map.setZoom(16)
          }
        })
      }
    }
  },
}
</script>
<style scoped>
</style>